/**
 * Quantas conquistas o usuário pode fixar na vitrine do perfil.
 *
 * Existe como constante única porque o número morava em TRÊS lugares que
 * discordavam (relato do fundador, 05/08): o `BadgePicker` do Settings deixava
 * escolher **3**, `updateHighlightedBadges` cortava em **3**, e a fileira do
 * Perfil desenha **4** — completando a 4ª vaga com a próxima conquista por
 * ordem, que o usuário nunca escolheu. Quem ajustava a vitrine via aparecer no
 * perfil uma medalha que não estava no editor.
 *
 * A fileira do perfil é a verdade (4 vagas, é o que o mock desenha), então o
 * editor e o servidor subiram até ela.
 *
 * ⚠️ ESTE NÚMERO TEM ESPELHO EM `firestore.rules` (`highlightedBadges.size()`).
 * Subir aqui sem deployar as rules faz a 4ª escolha ser RECUSADA pelo servidor
 * — e o auto-save do picker não tem tratamento de erro, então a medalha some
 * no próximo carregamento do perfil, sem aviso.
 */
export const MAX_HIGHLIGHTED_BADGES = 4;
